import { render, staticRenderFns } from "./SectionVideoGeneral.vue?vue&type=template&id=cb44563c&scoped=true&"
import script from "./SectionVideoGeneral.vue?vue&type=script&lang=js&"
export * from "./SectionVideoGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SectionVideoGeneral.vue?vue&type=style&index=0&id=cb44563c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb44563c",
  null
  
)

export default component.exports